// extracted by mini-css-extract-plugin
module.exports = {"content-title":"styles_content-title__CVtmi","content-links":"styles_content-links___LYPS"};